// When using these compenents wrap them all in an element with a className of 'skeleton'.
// [Optionally] Also include the classname of 'shimmer' to give all bone elements an animated shimmer

import { IconToggle } from "./IconToggle";
import { PageHeader } from "./PageHeader";
import { Panel } from "./Panel";
import { PrimaryTable } from "./PrimaryTable";

export {
  IconToggle,
  PageHeader,
  Panel,
  PrimaryTable,
};
